import { IconBriefcase, IconFileAnalytics, IconFileText, IconFolderOpen, IconNotes, IconListCheck } from '@tabler/icons-react';
import { generatePath, matchPath } from 'react-router-dom';
import { URLS } from 'services/urls';
import { TAB_TO_SLUG } from 'views/DealDashboard/constants';
import { ISideNavSection } from '../../interfaces';

const isDealDashboardActive = (pathname: string): boolean => {
    const dealDashboardPathMatch = matchPath(
        { path: URLS.DEAL_DASHBOARD.HOME, end: true },
        pathname,
    );
    const dealDashboardSubTabSlugs = Object.values(TAB_TO_SLUG);
    return dealDashboardPathMatch !== null
        && (!dealDashboardPathMatch.params.tab || dealDashboardSubTabSlugs.includes(dealDashboardPathMatch.params.tab));
};

export const buildDealSections = (dealId: string): ISideNavSection[] => [
    {
        id: 'dealHome',
        section: 'DEAL HOME',
        items: [
            {
                id: 'dealDashboard',
                label: 'Deal Dashboard',
                icon: IconBriefcase,
                kind: 'standard',
                to: generatePath(URLS.DEAL_DASHBOARD.HOME, { dealId }),
                isActive: isDealDashboardActive,
            },
            {
                id: 'tasks',
                label: 'Tasks',
                icon: IconListCheck,
                kind: 'standard',
                to: generatePath(URLS.TASKS.HOME, { dealId }),
            },
            {
                id: 'proForma',
                label: 'Pro Forma',
                icon: IconFileAnalytics,
                kind: 'standard',
                to: generatePath(URLS.PRO_FORMA.HOME, { dealId }),
            },
            {
                id: 'reportBuilder',
                label: 'Report Builder',
                icon: IconFileText,
                kind: 'standard',
                to: generatePath(URLS.REPORT_BUILDER, { dealId }),
            },
            {
                id: 'investmentMemo',
                label: 'Investment Memo',
                icon: IconNotes,
                kind: 'standard',
                to: generatePath(URLS.DEAL_INVESTMENT_MEMO, { dealId }),
            },
            {
                id: 'documents',
                label: 'Documents',
                icon: IconFolderOpen,
                kind: 'standard',
                to: generatePath(URLS.DOCUMENTS, { dealId }),
            },
        ],
    },
];
